module.exports = __webpack_public_path__ + "static/media/sustainability.f925d91e.png";